module.exports = __webpack_public_path__ + "img/vigiladoiris.f95efe44.png";